import React, { useState, useEffect } from "react" ;
import Form from 'react-bootstrap/Form'
import { getPostsByYear } from "root/DataFunctions/ChildDataFns";
import ChildPostDetailNew from "../Components/ChildPostDetailNew";

import "../styles/Pages/gallery.scss";

import GalleryItem from "../Components/GalleryItem";
import Loading from "../Components/Loading";

const Gallery = () => {
    const [galleryData, setGalleryData] = useState("");
    const [dropDownYear, setDropDownYear] = useState("all");

    const [index, setIndex] = useState(null);
    const filteredPost = galleryData.rows ? galleryData.rows[index] : '';

    // Loop gallery array
    const checkNumber = (number) => {
        if(number > galleryData.rows.length - 1) {
            return 0;
        }
        if (number < 0) {
            return galleryData.rows.length - 1;
        }
        return number;
    }
    
    const onNextPost = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    
    const onPrevPost = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const onSetIndexFromPost = (indx) => {
        setIndex(indx)
    }

    useEffect(() => {
        getPostsByYear(dropDownYear, true, (response) =>
        {
            setGalleryData(response);
        });
    }, [dropDownYear]);

    return (
        <div style={{flex: "1"}}>
            {console.log(galleryData)}
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">Gallery</h2>

                    <Form.Group controlId="formBasicSelect">
                        {/* <Form.Label>Select Norm Type</Form.Label> */}
                        <Form.Control
                            as="select"
                            value={dropDownYear}
                            onChange={e => {
                                setDropDownYear(e.target.value);
                              }}
                        >
                            {galleryData.years && galleryData.years.map((year) => {
                                return (
                                    <option key={year.year} value={year.year}>
                                        {year.year}
                                    </option>
                                )
                            })}

                            <option value="all">All</option>
                            <option value="LAST 12 MONTHS">Last 12 Months</option>
                        </Form.Control>
                    </Form.Group>

                </div>
            </div>
            <div className="gallery-cards">
                {galleryData.rows 
                    && index !== null 
                    && <ChildPostDetailNew 
                    totalPost={galleryData.rows.length} 
                    index={index} 
                    filteredPost={filteredPost} 
                    nextPost={onNextPost} 
                    prevPost={onPrevPost} 
                    setIndex={setIndex} 
                    />
                }
                {galleryData.rows 
                    ? galleryData.rows.map( (gallery, i) =>
                            gallery.image_array.map( (image, j) =>
                            <GalleryItem key={gallery.post_id} gallery={gallery} image={image} setIndexFromPost={onSetIndexFromPost} postIndex={i} />
                            )
                        )
                    : <Loading />
                }
            </div>
        </div>
    );
}

export default Gallery;
